export enum EnumVisitQuestionType {
  RadioButton,
  Comment,
  Date,
  Checkboxes,
  TimeSpan,
}
